// extracted by mini-css-extract-plugin
module.exports = {"container":"product-options_container__27MUf","item":"product-options_item__323M5","text":"product-options_text__4Gw_U"};